import { render, staticRenderFns } from "./StoreProductBody.vue?vue&type=template&id=0c8e03a8&scoped=true&"
import script from "./StoreProductBody.vue?vue&type=script&lang=js&"
export * from "./StoreProductBody.vue?vue&type=script&lang=js&"
import style0 from "./StoreProductBody.vue?vue&type=style&index=0&id=0c8e03a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e03a8",
  null
  
)

export default component.exports